<template>
    <div class="row">
        <div class="col-12">
            <b-button
                @click="showModal()"
            >
                Editar
            </b-button>
            <ModalComponent
                :name="modalName"
                title="Editar dirección fiscal"
                v-on:close="() => cerrar()"
            >  
                <Form :evento="data" @actualizado="editado()"/>
            </ModalComponent>
        </div>
    </div>    
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import Form from '@/components/backend/eventos/compania/FormComponent';

export default {
    props: {
        evento: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modalName: 'edit-evento-direccion-fiscal',
            data: Object.assign({}, this.evento)
        }
    },
    methods: {
        cerrar() {
            this.$modal.hide(this.modalName)
            this.data = Object.assign({}, this.evento);
        },
        showModal(){
            this.data = Object.assign({}, this.evento);
            this.$modal.show(this.modalName)
        },
        editado() {
            this.$emit('editado', this.data);
            this.cerrar();
        }
    },
    components: {
        ModalComponent, Form
    }
}
</script>
